// import React, { useEffect } from "react";
// import { Route, Routes, useLocation } from "react-router-dom";
// import Navbar from "./Component/Navbar/Navbar";
// import Footer from "./Component/Footer/Footer";
// import Home from "./Component/Home";
// import Login from "./Component/Login";
// import Realestate from "./Component/Realestate";
// import HomeDetail from "./Component/HomeDetail";
// import SmartSocial from "./Component/SmartSocial";
// import './App.css';

// const App = () => {
//   const location = useLocation();
  
//   const hideNavAndFooter = location.pathname.startsWith("/smartsocial");

//   useEffect(() => {
//     if (location.pathname.startsWith("/smartsocial")) {
//       document.body.classList.add('bg-smartsocial');
//     } else {
//       document.body.classList.remove('bg-smartsocial');
//     }
//     return () => {
//       document.body.classList.remove('bg-smartsocial');
//     };
//   }, [location.pathname]);

//   return (
//     <div className="flex flex-col min-h-screen">
//       {!hideNavAndFooter && <Navbar />}
//       <div className="flex-1">
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/realestate" element={<Realestate />} />
//           <Route path="/homedetail/:propertyId" element={<HomeDetail />} />
//           <Route path="/smartsocial/*" element={<SmartSocial />} />
//         </Routes>
//       </div>
//       {!hideNavAndFooter && <Footer />}
//     </div>
//   );
// };

// export default App;

// import React, { useEffect, useState, useRef } from "react";
// import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import Navbar from "./Component/Navbar/Navbar";
// import Footer from "./Component/Footer/Footer";
// import Home from "./Component/Home";
// import Login from "./Component/Login";
// import Realestate from "./Component/Realestate";
// import HomeDetail from "./Component/HomeDetail";
// import SmartSocial from "./Component/SmartSocial";
// import './App.css';
// import { CircularProgress } from '@mui/material';


// const App = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isReady, setIsReady] = useState(false); 
//   const isInitialLoad = useRef(true);

//   const hideNavAndFooter = location.pathname.startsWith("/smartsocial");


//   useEffect(() => {
//     if (location.pathname.startsWith("/smartsocial")) {
//       document.body.classList.add('bg-smartsocial');
//     } else {
//       document.body.classList.remove('bg-smartsocial');
//     }
//     return () => {
//       document.body.classList.remove('bg-smartsocial');
//     };
//   }, [location.pathname]);

//   useEffect(() => {
//     const initialize = async () => {
//       const isFirstVisit = sessionStorage.getItem("isFirstVisit");
//       const isPageLoad = performance.getEntriesByType("navigation")[0].type === "navigate" ||
//       performance.getEntriesByType("navigation")[0].type === "reload";

//       if (isFirstVisit && isPageLoad) {
//         setIsReady(true);
//         return;
//       }

//       sessionStorage.setItem("isFirstVisit", "true");

//       const pageView = localStorage.getItem("pageview");

//       if (pageView) {
//         redirectToPage(pageView);
//       } else {
//         setIsReady(true);
//       }
//     };

//     const redirectToPage = (page) => {
//       if (page.startsWith("property_detail/")) {
//         const propertyId = page.split("/")[1]; 
//         navigate(`/homedetail/${propertyId}`);
//         return;
//       }

//       switch (page) {
//         case "home_page_view":
//           navigate("/");
//           break;
//           case "realestate_view":
//             case "realestate_list_view":
//             case "realestate_map_view":
//               navigate("/realestate");
//               break;
        
//           case "smartsocial_vids":
//             navigate("/smartsocial");
//             break;
//         default:
//           navigate("/");
//       }

//       localStorage.setItem("pageview", page);
//       setIsReady(true); 
//     };

//     initialize();
//   }, [navigate]);

//   if (!isReady) {
//     return <div> <CircularProgress /> </div>;
//   }



//   return (
//     <div className="flex flex-col min-h-screen">
//       {!hideNavAndFooter && <Navbar />}
//       <div className="flex-1">
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/realestate" element={<Realestate />} />
//           <Route path="/homedetail/:propertyId" element={<HomeDetail />} />
//           <Route path="/smartsocial/*" element={<SmartSocial />} />
//         </Routes>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default App;

// import React, { useEffect, useState, useRef } from "react";
// import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import Navbar from "./Component/Navbar/Navbar";
// import Footer from "./Component/Footer/Footer";
// import Home from "./Component/Home";
// import Login from "./Component/Login";
// import Realestate from "./Component/Realestate";
// import HomeDetail from "./Component/HomeDetail";
// import SmartSocial from "./Component/SmartSocial";
// import './App.css';
// import { CircularProgress } from '@mui/material';

// const App = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isReady, setIsReady] = useState(false);
//   const isInitialLoad = useRef(true);

//   const hideNavAndFooter = location.pathname.startsWith("/smartsocial");

//   useEffect(() => {
//     if (location.pathname.startsWith("/smartsocial")) {
//       document.body.classList.add('bg-smartsocial');
//     } else {
//       document.body.classList.remove('bg-smartsocial');
//     }
//     return () => {
//       document.body.classList.remove('bg-smartsocial');
//     };
//   }, [location.pathname]);

//   useEffect(() => {
//     const fetchScreenNameFromAPI = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) {
//           throw new Error("Token not found in localStorage");
//         }

//         const response = await axios.get(
//           "http://dev.smartsuperapp.com/activity/v2/fetch-my-activity-logs?page_number=0&platform=web",
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         const screenName = response.data.data.activities[0].screenName;
//         console.log("screen",screenName)
//         if (screenName) {
//           localStorage.setItem("pageview", screenName);
//           redirectToPage(screenName);
//         } else {
//           setIsReady(true);
//         }
//       } catch (error) {
//         console.error("Error fetching screen name:", error);
//         setIsReady(true);
//       }
//     };

//     const initialize = async () => {
//       const isFirstVisit = sessionStorage.getItem("isFirstVisit");
//       const isPageLoad = performance.getEntriesByType("navigation")[0].type === "navigate" ||
//         performance.getEntriesByType("navigation")[0].type === "reload";

//       if (isFirstVisit && isPageLoad) {
//         setIsReady(true);
//         return;
//       }

//       sessionStorage.setItem("isFirstVisit", "true");

//       const pageView = localStorage.getItem("pageview");

//       if (pageView) {
//         redirectToPage(pageView);
//       } else {
//         await fetchScreenNameFromAPI();
//       }
//     };

//     const redirectToPage = (page) => {
//       if (page.startsWith("property_detail/")) {
//         const propertyId = page.split("/")[1];
//         navigate(`/homedetail/${propertyId}`);
//         return;
//       }

//       if (page.startsWith("profile_view/")) {
//         const parts = page.split("/");
//         const userid = parts[1];
      
//         if (parts.length === 3) {
//           if (parts[2] === "vids") {
//             navigate(`/smartsocial/${userid}/vids`);
//           } else if (parts[2] === "post") {
//             navigate(`/smartsocial/${userid}/post`);
//           }
//         } else {
//           navigate(`/smartsocial/${userid}`);
//         }
//         return;
//       }

//       if (page.startsWith("bookmark_view/")) {
//         const parts = page.split("/");
//         const userid = parts[1];
      
//         if (parts.length === 4) {
//           if (parts[3] === "vids") {
//             navigate(`/smartsocial/${userid}/saved/vids`);
//           } else if (parts[3] === "post") {
//             navigate(`/smartsocial/${userid}/saved/post`);
//           }
//         } else {
//           navigate(`/smartsocial/${userid}/saved`);
//         }
//         return;
//       }
      

//       switch (page) {
//         case "home_page_view":
//           navigate("/");
//           break;
//         case "realestate_view":
//         case "realestate_list_view":
//         case "realestate_map_view":
//           navigate("/realestate");
//           break;
//         case "smartsocial_vids":
//           navigate("/smartsocial/vids");
//           break;
//           case "smartsocial_post":
//             navigate("/smartsocial/post");
//             break;
//         default:
//           navigate("/");
//       }
//       setIsReady(true);
//     };

//     initialize();
//   }, [navigate]);

//   if (!isReady) {
//     return <div> <CircularProgress /> </div>;
//   }

//   return (
//     <div className="flex flex-col min-h-screen">
//       {!hideNavAndFooter && <Navbar />}
//       <div className="flex-1">
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/realestate" element={<Realestate />} />
//           <Route path="/homedetail/:propertyId" element={<HomeDetail />} />
//           <Route path="/smartsocial/*" element={<SmartSocial />} />
//         </Routes>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default App;


// import React, { useEffect, useState, useRef } from "react";
// import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
// import Navbar from "./Component/Navbar/Navbar";
// import Footer from "./Component/Footer/Footer";
// import Home from "./Component/Home";
// import Login from "./Component/Login";
// import Realestate from "./Component/Realestate";
// import HomeDetail from "./Component/HomeDetail";
// import SmartSocial from "./Component/SmartSocial";
// import './App.css';
// import { CircularProgress } from '@mui/material';
// import { fetchScreenNameAndRedirect, redirectToPage } from "./Config//LastActivity"; 
// import PrivacyPolicy from "./Public/PrivacyPolicy";
// import TermsAndConditions from "./Public/TermsAndConditions";
// import NotFound from "./NotFound";

// const App = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isReady, setIsReady] = useState(false);
//   const isInitialLoad = useRef(true);

//   const hideNavAndFooter = location.pathname.startsWith("/smartsocial");

//   useEffect(() => {
//     if (location.pathname.startsWith("/smartsocial")) {
//       document.body.classList.add('bg-smartsocial');
//     } else {
//       document.body.classList.remove('bg-smartsocial');
//     }
//     return () => {
//       document.body.classList.remove('bg-smartsocial');
//     };
//   }, [location.pathname]);

//   useEffect(() => {
//     const initialize = async () => {
//       const isFirstVisit = sessionStorage.getItem("isFirstVisit");
//       const isPageLoad = performance.getEntriesByType("navigation")[0].type === "navigate" ||
//         performance.getEntriesByType("navigation")[0].type === "reload";

//       if (isFirstVisit && isPageLoad) {
//         setIsReady(true);
//         return;
//       }

//       sessionStorage.setItem("isFirstVisit", "true");

//       const pageView = localStorage.getItem("pageview");

//       if (pageView) {
//         redirectToPage(pageView, navigate);
//       } else {
//         await fetchScreenNameAndRedirect(navigate, setIsReady);
//       }
//     };
   


    
//     initialize();
//   }, [navigate]);

//   if (!isReady) {
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         <CircularProgress />
//       </div>
//     );
//   }
  

//   return (
//     <div className="flex flex-col min-h-screen">
//       {!hideNavAndFooter && <Navbar />}
//       <div className="flex-1">
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/realestate" element={<Realestate />} />
//           <Route path="/homedetail/:propertyId" element={<HomeDetail />} />
//           <Route path="/smartsocial/*" element={<SmartSocial />} />
//           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
//          <Route path="*" element={<NotFound />} />
//         </Routes>
//       </div>
//       {!hideNavAndFooter && <Footer />}
//     </div>
//   );
// };

// export default App;

// import React, { useEffect, useState, useRef } from "react";
// import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
// import Navbar from "./Component/Navbar/Navbar";
// import Footer from "./Component/Footer/Footer";
// import Home from "./Component/Home";
// import Login from "./Component/Login";
// import Realestate from "./Component/Realestate";
// import HomeDetail from "./Component/HomeDetail";
// import SmartSocial from "./Component/SmartSocial";
// import './App.css';
// import { CircularProgress } from '@mui/material';
// import { fetchScreenNameAndRedirect, redirectToPage } from "./Config/LastActivity";
// import PrivacyPolicy from "./Public/PrivacyPolicy";
// import TermsAndConditions from "./Public/Termsandconditions";
// import LegalDisclaimer from "./Public/LegalDisclaimer";

// import NotFound from "./NotFound";

// const App = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isReady, setIsReady] = useState(false);

//   const validPaths = [
//     "/", "/login", "/realestate", "/privacy-policy", "/terms-and-conditions" , "/legal-disclaimer",
//   ];
//   const isSmartSocial = location.pathname.startsWith("/smartsocial");
//   const isValidPath =
//     validPaths.includes(location.pathname) ||
//     location.pathname.startsWith("/homedetail/") ||
//     location.pathname.startsWith("/smartsocial");

//   const hideNavAndFooter = isSmartSocial || !isValidPath;

//   useEffect(() => {
//     if (isSmartSocial) {
//       document.body.classList.add('bg-smartsocial');
//     } else {
//       document.body.classList.remove('bg-smartsocial');
//     }
//     return () => {
//       document.body.classList.remove('bg-smartsocial');
//     };
//   }, [location.pathname]);

//   useEffect(() => {
//     const initialize = async () => {
//       const isFirstVisit = sessionStorage.getItem("isFirstVisit");
//       const navType = performance.getEntriesByType("navigation")[0]?.type;
//       const isPageLoad = navType === "navigate" || navType === "reload";

//       if (isFirstVisit && isPageLoad) {
//         setIsReady(true);
//         return;
//       }

//       sessionStorage.setItem("isFirstVisit", "true");

//       const pageView = localStorage.getItem("pageview");

//       if (pageView) {
//         redirectToPage(pageView, navigate);
//       } else {
//         await fetchScreenNameAndRedirect(navigate, setIsReady);
//       }
//     };

//     initialize();
//   }, [navigate]);

//   if (!isReady) {
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         <CircularProgress />
//       </div>
//     );
//   }

//   return (
//     <div className="flex flex-col min-h-screen">
//       {!hideNavAndFooter && <Navbar />}
//       <div className="flex-1">
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/realestate" element={<Realestate />} />
//           <Route path="/homedetail/:propertyId" element={<HomeDetail />} />
//           <Route path="/smartsocial/*" element={<SmartSocial />} />
//           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//           <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
//           <Route path="/legal-disclaimer" element={<LegalDisclaimer />} />
//           <Route path="*" element={<NotFound />} />
//         </Routes>
//       </div>
//       {!hideNavAndFooter && <Footer />}
//     </div>
//   );
// };

// export default App;

import React from 'react'
import Home from "./AppDownload/Home";
import { Route , Routes, } from "react-router-dom";

const App = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </div>
     
  )
}

export default App